import { render } from "./Profile.vue?vue&type=template&id=586d5598"
import script from "./Profile.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Profile.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script